import {handleActions} from 'redux-actions'
import {CUSTOM_FIELDS_SET} from './actionTypes'

const createCustomFieldsSelector = () => {
    const initialState = {
        items: []
    }
    return handleActions({
        [CUSTOM_FIELDS_SET]: (state, {payload: customFields}) => ({
            ...state,
            items: customFields,
        })
    }, initialState)
}

export default createCustomFieldsSelector



// WEBPACK FOOTER //
// ./web/js/customFields/reducer.js